import React from 'react';
import '../assets/customStyles/custom.css';

import { Box as GBox } from 'grommet';
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";


const ProjectDetailsCard = ({project}) =>{
  let imageName = project.image
  return (
    <GBox animation="zoomIn" direction="column" style={{ alignItems: "center",  }} >

      <GBox elevation='xlarge' direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "#fff", width: 300, height: 350, }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={{ marginTop: 10, marginBottom: 2 }}>{project.name}</h3>
          <div style={{ backgroundColor: '#fff', display: 'flex', borderRadius: 50, justifyContent: 'center', alignContent: 'center' }} >
            <img width={50} height={50} alt='recipe box' src={require("../assets/images/"+imageName)} />
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
          {project.languagesUsed.map(i=> <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label={i} />)}
        </div>

        <p style={{ textAlign: "left", margin: 2, fontSize: 16 }}>{project.description}</p>
        <div id='link-label'>
          <h5 style={{ fontSize: 14, margin: 5,marginBottom:0,paddingBottom:1,marginTop:10  }}>Links</h5>
        </div>

        <div style={{ position: 'relative', width: '90%',  display: 'flex', backgroundColor: 'transparent', borderRadius: 50, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', }}>
        
          <div style={{ display: 'flex', width: '90%', backgroundColor: '#fff', borderRadius: 50, justifyContent: 'flex-start', alignItems: 'flex-start', }}>
            {project.links.map(i => <Button target={'_blank'} href={i.link} style={{ color: "#E04D01", borderRadius: 20, padding: 3, marginRight: 6, marginLeft: 2}}>{i.label}</Button>)}
          </div>
        </div>
      </GBox>
    </GBox>
  )
}

export default ProjectDetailsCard